<template>
  <tr class="applicant-list" :style="bgColor">
    <td class="col-checkbox text-center" data-testid="checkbox-cell">
      <input
              type="checkbox"
              v-bind:value="applicantData.id"
              @change="checkUncheckJobseeker(applicantData.id)"
              :checked="isChecked" style="margin-top:4px;"
      />
    </td>
    <td
      class="col-spacer"
      style="padding-left:0px !important;"
      @click="showProfile"
      data-testid="row-number-cell"
    >{{rowNumber}}</td>
    <template>

      <td
        v-if="!isReviewer || isPreview"
        class="col-review-date td-date text-center"
        @click="showProfile"
        data-testid="review-date-cell"
      >
        <div class="date-container d-flex flex-column align-items-center text-center">
          <span>{{ reviewListAddedDate }}</span>
        </div>
      </td>
      <!-- 1. Registered/Updated Date -->
      <td
        class="col-joined-date td-date text-center"
        @click="showProfile"
        data-testid="joined-date-cell"
      >
        <div class="date-container d-flex flex-column align-items-center text-center">
          <span>{{ joinedDate }}</span>
        </div>
      </td>

      <!-- 2. Via -->
      <td class="col-via text-center" @click="showProfile" data-testid="via-cell">
         <div class="d-flex flex-column align-items-center">
            <span
              v-if="applicantData.companyFrom === '自社'"
            >自社</span>
         </div>
      </td>

      <!-- 3. Scout Wish -->
      <td class="col-scout text-center" @click=showProfile data-testid="scout-cell">
        <span v-if="applicantData.hasActiveScout" class="scout-mark">○</span>
        <!-- Debug: {{ applicantData.hasActiveScout }}
        Force show for testing: -->
        <!-- <span class="scout-mark">○</span> -->
      </td>

      <!-- 4. Name -->
      <td
        class="col-name text-left"
        @click="showProfile"
        data-testid="name-cell"
      >
         <span
            class="client-name line-clamp-2"
            v-html="getHighlightedContent(['full_name', 'last_name'], `${applicantData.last_name} ${applicantData.name}`)"
            style="cursor: pointer;font-weight: bold;"
          ></span>
      </td>

      <!-- 5. Age -->
      <td class="col-age text-center" @click="showProfile" data-testid="age-cell">
          <span>{{applicantData.age}}</span>
      </td>

      <!-- 6. School -->
      <td class="col-graduation text-left" @click="showProfile" data-testid="graduation-cell">
          <span class="line-clamp-2" v-html="getHighlightedContent(['graduation_school_name'], applicantData.education.instituteName)"/>
      </td>

      <!-- 7. Company -->
      <td class="col-company text-left" @click="showProfile" data-testid="company-cell">
         <span class="line-clamp-2" v-html="getHighlightedContent(['recent_registered_company_name'], employment.lastCompany)"></span>
      </td>

      <!-- 8. Job -->
      <td class="col-job text-left" @click="showProfile" data-testid="job-cell">
         <span class="line-clamp-3"> {{employment.lastJob.title}} <br/> ( {{employment.lastJob.child.title}} )</span>
      </td>

      <!-- 9. Income -->
      <td class="col-income text-center" @click="showProfile" data-testid="income-cell">
          <span>{{employment.lastYearIncome}} 万円</span>
      </td>

      <!-- 10. Memo -->
      <td class="col-memo text-right" data-testid="memo-cell">
        <div class="d-flex justify-content-center note-btn-grp">
          <Favorite
            :favorite="applicantData.isFavorite"
            @click.native="toggleFavorite(applicantData)"
            :toggledisabled="loading"
            data-testid="favorite-button"
          />
          <span class="ms-2"></span>
          <Memo v-bind:key="applicantData.id+applicantData.memo" :applicant="applicantData"/>
        </div>
      </td>

<td class="col-status text-center status-cell" data-testid="status-cell">
      <StatusDropDown
        :applicant="applicantData"
        :isReviewer="isReviewer"
        @hidden="$emit('hidden')"
        @shown="$emit('shown')"
        @statusChanged="statusChanged"
        :class="colorClass"
        :toggledisabledstatus="loading"
        :fromList="true"
      />
    </td>

<!-- <td class="col-actions text-center"></td> -->
  </template>
    <ProfileModal
      v-if="showProfileModal"
      :applicantId="applicantData.id"
      :applicantIndex="applicantIndex"
      :isFavorite="applicantData.isFavorite"
      :isInterview="applicantData.isInterview"
      :applicantdata="applicantData"
      :showProfileModal="showProfileModal"
      :isPreview="isPreview"
      :isPendingReview="isPendingReview"
      v-on:hideModal="hideProfile"
    />
    <ReviewListPopup 
      ref="reviewListPopup" 
      v-if="showReviewListModal"
      :applicant="applicantData"
      :showReviewListModal="showReviewListModal"
      @hideModal="hideReviewList"
    />
    <ConfirmationPopup
      ref="confirmationPopUp"
      :modalText="detailsText"
      :buttonText="buttonText"
      @submit="processSubmission"
      @cancel="hideConfirmationModal"
      v-if="openConfirmationPopup"
    />
  </tr>
</template>

<script>
import Favorite from '@/components/dashboard/applicants/Favorite.vue';
import Interview from '@/components/dashboard/applicants/Interview.vue';
import ColorCategory from '@/components/dashboard/applicants/ColorCategory.vue';
import Memo from '@/components/dashboard/applicants/Memo.vue';
import ProfileModal from '@/components/dashboard/applicants/profile/ProfileModal.vue';
import StatusDropDown from '@/components/dashboard/StatusDropDown.vue';
import ScoutButton from '@/components/dashboard/ScoutButton.vue';
import ReviewListPopup from '@/components/dashboard/ReviewListPopup.vue';
import ConfirmationPopup from './profile/ConfirmationPopup.vue';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import moment from 'moment';
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'ApplicantRow',
  components: {
    Memo,
    Favorite,
    Interview,
    ProfileModal,
    StatusDropDown,
    ColorCategory,
    ScoutButton,
    ReviewListPopup,
    ConfirmationPopup,
  },
  props: [
    'applicant',
    'applicantIndex',
    'rowNumber',
    // 'isChecked',
    'isPreview',
    'isPendingReview'
  ],
  data() {
    return {
      rowColor: this.applicant.color,
      applicantData: this.applicant,
      showProfileModal: false,
      loading: false,
      isCheckSome: false,
      showReviewListModal: false,
      openConfirmationPopup: false,
      option: '',
      isScoutLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      getMenus: 'getMenus',
      isReviewer: 'isCreateReviewUser',
      isAdmin: 'currentUserIsAdmin',
      statusColorMap: 'getStatusColorMap'
    }),
    ...mapState({
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
    }),
    detailsText() {
      if (this.option == 'list') {
        return 'スカウトする求人が選択されていません <br/> このまま判定を依頼しますか？';
      } else {
        return 'スカウトする求人が選択されていません<br/> このままスカウト候補へ追加しますか？';
      }
    },
    buttonText() {
      if (this.option == 'list') {
        return '判定を依頼する';
      } else {
        return 'スカウト候補へ追加';
      }
    },
    isChecked() {
      return this.jobseekerIds.includes(this.applicant.id)
    },
    // isApplicantRead() {
    //   return this.applicant.profile_view_status === 'read';
    // },
    bgColor() {
      // if(this.applicant.profile_view_status === 'read') {
      //   return 'background-color: #D9D9D9'
      // } else {
        return 'background-color:#fff';
      // }
    },
    judgementText() {
      return this.isPreview ? '対象から除外' : (this.isReviewer ? '判定を依頼する' : '対象から除外');
    },
    // bgColor() {
    //   let color;
    //   if (this.rowColor == '#fff') {
    //     color = '#fbfcff';
    //   } else {
    //     color = this.rowColor;
    //   }
    //   return `background-color: ${color}`;
    // },
    joinedDate() {
      return this.formatDate(this.applicantData.joinedDate);
    },
    reviewListAddedDate() {
      return this.formatDate(this.applicantData.reviewListAddedDate);
    },
    checked() {
      return this.isChecked ? 'checked' : '';
    },
    employment() {
      return this.applicantData.employment;
    },
    imagePath() {
      return this.applicantData.imagePath;
    },
    colorClass() {
      const status = this.applicantData.new_status || this.applicantData.status;
      // Return status-based class name for new color system
      if (status && this.statusColorMap[status]) {
        return `status-${status}`;
      }
      return '';
    },
  },

  methods: {
    ...mapMutations({
      mutateApplicantsAfterFav: 'mutateApplicantsAfterFav',
      mutateApplicantsAfterInterview: 'mutateApplicantsAfterInterview',
      checkUncheckJobseeker: 'checkUncheckJobseeker',
      setReloadApplicants: 'setReloadApplicants',
      mutateApplicantReadStatus: 'mutateApplicantReadStatus',
      setScoutedJd: 'setScoutedJd',
      setApplicantStatus: 'setApplicantStatus',
    }),
    formatDate(date, format = 'YYYY-MM-DD') {
      if (!date) return '';
      return moment(date)
        .utcOffset('+0900')
        .format(format);
    },
    jobTitle(job) {
      return job.jobDetails.job_title || '';
    },
    formatScoutedDate(date) {
      return this.formatDate(date, 'YYYY/MM/DD');
    },
    jdTitle(jd) {
      return jd.jobDescriptionTitle;
    },
    async processSubmission() {
      this.openConfirmationPopup = false;
      if (this.option == 'list') {
        this.requestJudgement();
      } else {
        await this.toggleScout();
      }
    },
    hideConfirmationModal() {
      this.openConfirmationPopup = false;
      // this.$refs.confirmationModal.close();
    },
    async checkJdAssigned(option) {
      // Handle preview and non-reviewer cases first
      if (option === 'list' && (this.isPreview || !this.isReviewer)) {
        this.requestJudgement();
        return;
      }

      const hasMarkedJobseekers = this.applicantData.markedjobseekers.length > 0;

      if (!hasMarkedJobseekers) {
        this.option = option;
        this.openConfirmationPopup = true;
        return;
      }

      if (option === 'list') {
        this.requestJudgement();
      } else {
        await this.toggleScout();
      }
    },
    async toggleScout() {
      try {
        this.isScoutLoading = true;
        await ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
          status: 'スカウト対象',
          isNewPanel: true,
        });
        this.setReloadApplicants(true);
      } catch (error) {
        console.log(error);
        this.parseErrorResponse(error.response);
      } finally {
        this.isScoutLoading = false;
      }
    },
    requestJudgement() {
      if (this.isPreview || !this.isReviewer) {
        this.removeFromReviewList();
        return;
      }
      this.showReviewListModal = true;
    },
    removeFromReviewList() {
      this.loading = true;
      ApiService.put(Api.endpoints.REMOVE_FROM_REVIEW_LIST(this.applicant.id))
        .then(({ data }) => {
          this.setReloadApplicants(true);
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.loading = false;
        });
    },
    hideReviewList() {
      this.showReviewListModal = false;
    },
    getHighlightedContent(paths, originalText) {
      if (!this.applicantData.highlights || !this.applicantData.highlights.length) {
        return originalText;
      }

      // Special handling for name fields
      if (paths.includes('last_name') || paths.includes('full_name')) {
        let highlightedText = originalText;

        const nameHighlights = this.applicantData.highlights.filter(h => 
          paths.includes(h.path) && h.texts && h.texts.length
        );

        for (let highlight of nameHighlights) {
          // Sort hit texts by length (longest first) to handle overlapping matches
          const hitTexts = highlight.texts
            .filter(t => t.type === 'hit')
            .sort((a, b) => b.value.length - a.value.length);

          // Process each hit text separately
          for (let hitText of hitTexts) {
            const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
            highlightedText = highlightedText.replace(
              searchRegex, 
              match => `<span class="highlight-hit">${match}</span>`
            );
          }
        }

        return highlightedText;
      }

      // Regular handling for other fields
      const highlights = this.applicantData.highlights.filter(h => paths.includes(h.path));
      if (highlights.length === 0) {
        return originalText;
      }

      let highlightedText = originalText;

      for (let highlight of highlights) {
        // Sort hit texts by length (longest first) to handle overlapping matches
        const hitTexts = highlight.texts
          .filter(t => t.type === 'hit')
          .sort((a, b) => b.value.length - a.value.length);

        // Process each hit text separately
        for (let hitText of hitTexts) {
          const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
          highlightedText = highlightedText.replace(
            searchRegex, 
            match => `<span class="highlight-hit">${match}</span>`
          );
        }
      }

      return highlightedText;
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    formatHighlightText(texts) {
      return texts.map(text => {
        if (text.type === 'hit' || text.type === 'text') {
          return `<span class="highlight-hit">${text.value}</span>`;
        }
        return text.value;
      }).join('');
    },
    changeRowColor(color) {
      this.rowColor = color;
    },
    toggleFavorite(applicant) {      
      this.loading = true;
      const method = applicant.isFavorite ? 'delete' : 'put';
      ApiService[method](Api.endpoints.FAVORITE(applicant.id))
        .then(({ data }) => {
          // this.applicantData = data.data;
          this.mutateApplicantsAfterFav(data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
        });
    },

    toggleInterview(applicant) { 
      this.loading = true;
      const method = applicant.isInterview ? 'delete' : 'put';
      ApiService[method](Api.endpoints.INTERVIEW(applicant.id))
              .then(({ data }) => {
        // this.applicantData = data.data;
      this.mutateApplicantsAfterInterview(data.data);
    })
    .catch(({ response }) => this.parseErrorResponse(response))
    .then(() => {
        this.loading = false;
    });
    },
    // async toggleReadStats(status='read') {
    //   try {
    //     const statusToUpdate = status === 'read' ? 'read' : 'unread';

    //     const {data} = await ApiService.put(Api.endpoints.MARK_APPLICANT_READ(this.applicantData.id), {
    //       status: statusToUpdate
    //     });
    //     const response = data.data;
    //     if(response){
    //       this.applicantData.profile_view_status = statusToUpdate;
    //     }
    //     this.mutateApplicantReadStatus({
    //       id: this.applicantData.id,
    //       profile_view_status: statusToUpdate
    //     });
    //   } catch (error) {
    //     console.error('Error marking applicant as read:', error);
    //     // Failed to mark as read, but user can still view profile
    //   }
    // },
    showProfile(job = null) {
      this.showProfileModal = true;
      if (job) {
        this.setScoutedJd(job.jobDetails);
      }
      // this.toggleReadStats();
    },
    hideProfile() {
      this.showProfileModal = false;
    },
    statusChanged(data) {
      // data contains the full applicant object from API response
      // Priority: new_status first, then fall back to status
      // Use $set to ensure reactivity
      if (data.new_status !== undefined && data.new_status !== null) {
        this.$set(this.applicantData, 'new_status', data.new_status);
      }
      if (data.status !== undefined && data.status !== null) {
        this.$set(this.applicantData, 'status', data.status);
      }
    },
    logout() {
      this.$router.push('/logout');
    },
  },
  watch: {
    applicant: {
      handler(newApplicant) {
        // Only update fields that need highlighting
        const fieldsToUpdate = {
          highlights: newApplicant.highlights,
          last_name: newApplicant.last_name,
          name: newApplicant.name,
          education: newApplicant.education,
          employment: newApplicant.employment,
          hasActiveScout: newApplicant.hasActiveScout,
        };

        Object.assign(this.applicantData, fieldsToUpdate);
      },
      deep: false,
    },
    'applicant.status': function status(newStatus) {
      this.$set(this.applicantData, 'status', newStatus);
    },
    'applicant.new_status': function newStatus(newStatus) {
      this.$set(this.applicantData, 'new_status', newStatus);
    },
    'applicant.isFavorite': function favorite() {
      this.applicantData.isFavorite = this.applicant.isFavorite;
    },
    'applicant.isInterview': function interview() {
      this.applicantData.isInterview = this.applicant.isInterview;
    },
    'applicant.memo': function memo() {
      this.applicantData.memo = this.applicant.memo;
    },
    'applicant.markedjobseekers': function markedjobseekers(newVal) {
      // console.log(newVal);
      this.applicantData.markedjobseekers = newVal;
    },
    'applicant.hasActiveScout': function hasActiveScout(newVal) {
      this.applicantData.hasActiveScout = newVal;
    },
  },
};
</script>

<style scoped>
.truncate-title {
  display: inline-block;
  max-width: 90%;
  white-space: nowrap;   /* keep in one line */
  overflow: hidden;      /* cut off overflow */
  text-overflow: ellipsis; /* show ... */
  vertical-align: bottom;
}

.btn-read i{
  color: #3C3C3C;
  background-color: #fff;
}
.scouted-jobs {
  /* font-size: 12px; */
  color: #036AC9;
  display: block;
}
.note-btn-grp button {
  width: 20px;
}
.client-listing-detail tr:hover {

}
.status-cell {
  font-weight: bold;
  font-size: 16px;
}
.status-cell.status-pending {
  color: #EB5757;
}

.company-source-text {
  font-weight: bold;
  color: #3c3c3c;
  border: 1px solid #3c3c3c;
  padding: 2px 8px;
  border-radius: 4px;
}

.scout-mark {
  font-size: 18px;
  color: #333;
}

/* Line clamping utilities */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
}

.note-btn-grp >>> .btn-plain {
  padding: 5px !important;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
}

.note-btn-grp >>> .btn-plain:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

</style>
<style>

.company-source-label {
  width: 122px !important;
  height: 30px !important;
  object-fit: contain;
  margin-right: 12px;
}

.highlight-hit{
  background-color: #ffd700 !important;
  padding: 0 2px;
  border-radius: 2px;
  font-weight: 500;
}
/* Status button styles are now in global _status_buttons.scss */

.applicant-list td {
  padding: 5px 7px !important;
  border-bottom: 1px solid #787878;
}

.applicant-list:hover {
  /*border-right: solid 2px #0e0e0e6b;*/
  /*border-left: solid 2px #0e0e0e6b;*/
  /*box-shadow:rgba(50, 52, 93, 0) 1px 0px 20px 4px inset, rgb(0 0 0 / 10%) 0px 0px 20px 0px inset;*/

  /*-webkit-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
  /*-moz-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
  /*box-shadow: */
  box-shadow: rgba(67, 71, 85, 0.6) 0px 0px 0.5em, rgba(90, 125, 188, 0.3) 0px 0.5em 2em;
  z-index: 1;
  /*background-color: #f0f5f7!important;*/

  border: 4px solid #036d6c !important;
  /*background-color: #F0F8FD!important;*/

}

.wrapword {
  white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: pre-wrap; /* css-3 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
  word-break: break-all;
  white-space: normal;
}

.block-with-text {
  /* hide text if it more than N lines  */
  overflow: hidden;
  /* for set '...' in absolute position */
  position: relative;
  /* use this value to count block height */
  line-height: 1.2em;
  /* max-height = line-height (1.2) * lines max number (3) */
  max-height: 3.6em;
  /* fix problem when last visible word doesn't adjoin right side  */
  text-align: justify;
  /* place for '...' */
  margin-right: -1em;
  padding-right: 1em;
}
.min-height-50 {
    min-height: 50px;
}

.text-center {
  min-width: 50px !important;
}

.applicant-list >td:hover {
  /*font-weight:600!important;*/
  /*text-decoration: underline;*/
  color:#1e6d6b!important;
}
.note-btn-grp >.btn-heart i:hover{
  color:#aba2a2!important;
}
.fa-sticky-note:hover{
  color:#aba2a2!important;
}
.client-listing-detail table td:first-child {
  min-width:25px!important;
}
.client-listing-detail table td:last-child {
  min-width:25px!important;
}

.scouted-date {
  cursor: default;
  color: #3c3c3c;
  text-decoration: none;
  pointer-events: none;
  display: block;
  text-align: center;
  width: 100%;
  margin: 0 auto;
}

</style>